import { render, staticRenderFns } from "./BusinessesIndex.vue?vue&type=template&id=2e247c19&scoped=true"
import script from "./BusinessesIndex.vue?vue&type=script&lang=js"
export * from "./BusinessesIndex.vue?vue&type=script&lang=js"
import style0 from "./BusinessesIndex.vue?vue&type=style&index=0&id=2e247c19&prod&lang=scss&scoped=true"
import style1 from "./BusinessesIndex.vue?vue&type=style&index=1&id=2e247c19&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e247c19",
  null
  
)

export default component.exports